import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateQR } from '../../apis/generateOffer.service';
import Swal from 'sweetalert2';

const GenerateOffer = () => {
  const navigate = useNavigate();
  const [userid, setUserid] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    setUserid(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!userid) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Please enter a User ID',
      });
      return;
    }

    try {
      setLoading(true);
      var token = localStorage.getItem("token").replaceAll(/"/g,"") || "";
      
      const qrImageUrl = await generateQR(userid, token);
      
      // Show QR code in popup
      Swal.fire({
        title: 'QR Code Generated',
        html: `
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="${qrImageUrl}" alt="QR Code" style="max-width: 300px; border: 2px solid #0b8a0b; border-radius: 8px; margin-bottom: 20px;" />
            <p style="color: #0b8a0b; font-weight: bold;">Scan this QR code</p>
          </div>
        `,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Close',
        confirmButtonColor: '#0b8a0b',
        width: '400px',
        customClass: {
          popup: 'qr-popup'
        }
      }).then(() => {
        // Clean up the blob URL when popup is closed
        URL.revokeObjectURL(qrImageUrl);
      });

    } catch (error) {
      console.error('Error generating QR code:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to generate QR code. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-body py-3 px-md-5 w-100" style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <div className="row d-flex justify-content-center">
        <div style={{ paddingTop: '22px' }} className="col-lg-8 d-flex flex-column align-items-center">
          <h2 style={{ color: "#0b8a0b", marginBottom: "30px" }}>Generate Offer</h2>
          <form className='col-12' onSubmit={handleSubmit}>
            <div className="form-outline mb-4 d-flex flex-column">
              <label style={{ marginTop: '6px' }} className="form-label" htmlFor="userid">
                User ID
              </label>
              <input
                type="text"
                id="userid"
                value={userid}
                onChange={handleChange}
                name="userid"
                placeholder="Enter userid"
                className="form-control"
                required
              />
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                type="submit"
                style={{ backgroundColor: "#0b8a0b", color: "white", padding: "10px 40px" }}
                className="btn"
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "Generate Offer"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GenerateOffer;
